import { styled } from "react-alicerce-components";

export const Container = styled.div`
    border:1px solid #E4E9F2;
    border-radius: 16px;
`